module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/3-d35f69a8052ee710790e29f717e85972.jpg";